import { useTranslation } from 'react-i18next'

import { Card, CardTitle } from '@reveni-io/reveni-ui'

import { trackingTypes } from '../constants'
import CarrierInfo from './CarrierInfo/CarrierInfo'
import DeliveryEta from './DeliveryEta/DeliveryEta'
import DestinationInfo from './DestinationInfo/DestinationInfo'
import Rating from './Rating/Rating'
import Status from './Status/Status'
import SubStatus from './SubStatus/SubStatus'
import Timeline from './Timeline/Timeline'
import * as Styles from './styles'

const OrderInfoCard = ({ info }) => {
  const { t } = useTranslation()

  const getTitle = () => {
    if (info?.type === trackingTypes.shipment || info?.type === trackingTypes.fulfillment) {
      return t('Pedido')
    } else if (info?.type === trackingTypes.return) {
      return t('Devolución')
    }
  }

  return (
    <>
      <Rating
        status={info?.status}
        trackingId={info?.id}
        customerRatingBlockEnabled={info?.portal?.preferences?.customer_rating_block_enabled}
      />
      <Card>
        <CardTitle>
          {getTitle()} {info?.order_name}
        </CardTitle>
        <Styles.Container>
          <Status info={info} />
          <SubStatus info={info} />
          <Timeline timeline={info?.timeline} timezone={info?.address?.country?.timezone} />
          <DeliveryEta date={info?.eta} type={info?.type} timezone={info?.address?.country?.timezone} />
          <DestinationInfo
            address={info?.address}
            portalName={info?.portal?.name}
            isPickupPoint={info?.is_pickup_point}
            type={info?.type}
          />
          <CarrierInfo carrier={info?.carrier} trackingNumber={info?.tracking_number} />
        </Styles.Container>
      </Card>
    </>
  )
}

export default OrderInfoCard
